import {
  addDays,
  formatArabicDate,
  todayStr,
  isToday,
  relativeDayLabel,
} from '../lib/dates.js';

export default function DateNav({ selectedDate, onSelectDate, onPrint }) {
  const relative = relativeDayLabel(selectedDate);

  return (
    <section className="date-nav">
      <div className="date-nav-heading">
        <h2>{formatArabicDate(selectedDate)}</h2>
        {relative && <span className="is-today">{relative}</span>}
      </div>

      <div className="date-nav-controls">
        {/* The page is RTL, so the arrow pointing right moves back in time. */}
        <button
          type="button"
          className="btn btn-icon"
          onClick={() => onSelectDate(addDays(selectedDate, -1))}
          aria-label="اليوم السابق"
          title="اليوم السابق"
        >
          ›
        </button>

        <button
          type="button"
          className="btn"
          onClick={() => onSelectDate(todayStr())}
          disabled={isToday(selectedDate)}
        >
          اليوم
        </button>

        <button
          type="button"
          className="btn btn-icon"
          onClick={() => onSelectDate(addDays(selectedDate, 1))}
          aria-label="اليوم التالي"
          title="اليوم التالي"
        >
          ‹
        </button>

        <input
          type="date"
          className="date-input"
          value={selectedDate}
          onChange={(event) => {
            if (event.target.value) onSelectDate(event.target.value);
          }}
          aria-label="اختيار التاريخ"
        />

        <button type="button" className="btn" onClick={onPrint} title="طباعة الجدول">
          🖨 طباعة
        </button>
      </div>
    </section>
  );
}
